export const LIST_ITEM_COPY = {
  NO_POLICY: 'No Policy',
  NOT_LINKED: 'Not Linked',
  NO_FRAMEWORK: 'No Framework',
  NOT_APPLICABLE_POLICY: 'N/A Policy',
}

// GRC platforms an imported control can be linked back to.
export const LINKABLE_RECEPTOR_MODEL_IDS = ['trr-onspring', 'trr-smartsuite']
